import { useEffect, useState } from "react";
import RangeDatePickerFilter from "../../pages/custom/filters/RangeDatePickerFilter";
import { getLast6Months, getLastMonth, getLastWeek, getThisMonth, getThisYear, getThisWeek } from "../../../../lib/dateScripts";

export default function DateRangeOption({filtersValues, item, mainSelectAction, classes, workQ, hideLabel}) {

    const [hideItem, setHideItem] = useState(false)
    const [minMaxDates, setMinMaxDates] = useState(null)
    useEffect(() => {
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) {
                const cfg = workQ.filter_conditions[item.key]
                if (!cfg || typeof cfg !== 'object') {
                    return
                }

                switch (cfg.type) {
                    case 'today':
                        setHideItem(true)
                        break;
                    case 'tomorrow':
                        setHideItem(true)
                        break;
                    case 'this_week':
                        setMinMaxDates(getThisWeek(new Date(), true))
                        break;
                    case 'last_week':
                        setMinMaxDates(getLastWeek(new Date(), true))
                        break;
                    case 'this_month':
                        setMinMaxDates(getThisMonth(new Date(), true))
                        break;
                    case 'last_month':
                        setMinMaxDates(getLastMonth(true))
                        break;
                    case 'last_6_month':
                        setMinMaxDates(getLast6Months(true))
                        break;
                    case 'this_year':                        
                        setMinMaxDates(getThisYear(new Date(), true))
                        break;
                    default:
                        break;
                }
            }
        }
    }, [workQ, item])

    return <>
        {!hideItem && <div className={classes.row}>
            <RangeDatePickerFilter
                preSelectedValue={filtersValues && filtersValues[item.key] && filtersValues[item.key]}
                label={hideLabel ? null : item.label}
                identifier={{type: item.key}}
                fullWidth={true}
                action={mainSelectAction}
                minMax={minMaxDates}
            />
        </div>}
    </>
}